import CommandCenter from "./CommandCenter";

export default function WeekOverview() {
  return <CommandCenter />;
}
